"use client";
import { jsxs as r, Fragment as e, jsx as o } from "react/jsx-runtime";
import i from "@kmx/mui-icons/KmxMinusStroked";
import c from "@kmx/mui-icons/KmxPlusStroked";
import { styled as n } from "@mui/material/styles";
const d = n(i)(() => ({
  ".MuiAccordionSummary-expandIconWrapper:not(.Mui-expanded) &": {
    display: "none"
  }
})), m = n(c)(() => ({
  ".MuiAccordionSummary-expandIconWrapper.Mui-expanded &": {
    display: "none"
  }
})), u = () => /* @__PURE__ */ r(e, { children: [
  /* @__PURE__ */ o(m, {}),
  /* @__PURE__ */ o(d, {})
] });
export {
  u as default
};
